var map = {
	"./404_error.svg": 9056,
	"./500_error.svg": 881,
	"./Apple_store_badge_135px.png": 5942,
	"./Flexibility Stacked.png": 7406,
	"./IndividualPlan/StillOnTrial.png": 8736,
	"./Integration.png": 986,
	"./OnDeviceheader.png": 636,
	"./ab-homepage/analytics-wht.png": 307,
	"./ab-homepage/analytics.png": 3215,
	"./ab-homepage/app-builder-desktop.png": 2415,
	"./ab-homepage/customize-wht.png": 502,
	"./ab-homepage/customize.png": 6238,
	"./ab-homepage/database.png": 3920,
	"./ab-homepage/device-pdf.png": 6488,
	"./ab-homepage/devices.png": 662,
	"./ab-homepage/illhandwrit.png": 6729,
	"./ab-homepage/integrate.png": 8558,
	"./ab-homepage/learn-desktop.png": 9602,
	"./ab-homepage/missing-form.png": 5072,
	"./ab-homepage/mobile-share.png": 831,
	"./ab-homepage/no-custom.png": 7584,
	"./ab-homepage/photocapt.png": 9399,
	"./ab-homepage/process.png": 3968,
	"./ab-homepage/snail.png": 828,
	"./ab-homepage/storage.png": 6164,
	"./ajax_loader.gif": 5287,
	"./alt_star.gif": 8469,
	"./app-builder-bg.svg": 3520,
	"./app-store/app-icons/Inspections_Surveys.svg": 9635,
	"./app-store/app-store-detail/Capterra_white.png": 1948,
	"./app-store/app-store-detail/G2_white.png": 1965,
	"./app-store/app-store-detail/GetApp_white.png": 8347,
	"./app-store/app-store-detail/SoftwareAdvice_white.png": 4365,
	"./app-store/app-store-detail/android.svg": 9528,
	"./app-store/app-store-detail/apple_icon.svg": 5031,
	"./app-store/app-store-detail/feature-icons/Barcode_Scanning.svg": 8571,
	"./app-store/app-store-detail/feature-icons/Calculations.svg": 8495,
	"./app-store/app-store-detail/feature-icons/Dispatch.svg": 7847,
	"./app-store/app-store-detail/feature-icons/Electronic_Signature.svg": 7092,
	"./app-store/app-store-detail/feature-icons/Gps.svg": 2483,
	"./app-store/app-store-detail/feature-icons/Mobile_Payments.svg": 3947,
	"./app-store/app-store-detail/feature-icons/Reference_Data.svg": 5307,
	"./app-store/app-store-detail/feature-icons/Submissions_Editing.svg": 2125,
	"./app-store/app-store-detail/feature-icons/animation-6.gif": 1132,
	"./app-store/app-store-detail/feature-icons/conditional_field.svg": 446,
	"./app-store/app-store-detail/feature-icons/image_capture.svg": 6959,
	"./app-store/app-store-detail/window.svg": 1235,
	"./app-store/backgrounds/laptop-bg.png": 9386,
	"./app-store/backgrounds/listing_hero.jpg": 4291,
	"./app-store/backgrounds/phone-bg-animation.png": 3125,
	"./app-store/backgrounds/phone-bg.png": 6248,
	"./app-store/backgrounds/squares-hero.svg": 3998,
	"./app-store/backgrounds/video-img-crop.jpg": 18,
	"./app-store/backgrounds/video-img.jpg": 453,
	"./app-store/backgrounds/video-overlay2.png": 5152,
	"./app-store/form-type-page/chart-bar.svg": 8473,
	"./app-store/form-type-page/clipboard-check.svg": 6436,
	"./app-store/form-type-page/clock.svg": 5727,
	"./app-store/form-type-page/cogs.svg": 7387,
	"./app-store/form-type-page/desktop.svg": 2521,
	"./app-store/form-type-page/file-alt.svg": 7035,
	"./app-store/form-type-page/file.svg": 6649,
	"./app-store/form-type-page/keyboard.svg": 4108,
	"./app-store/form-type-page/money-check-alt.svg": 3640,
	"./app-store/form-type-page/project-diagram.svg": 7630,
	"./app-store/form-type-page/random.svg": 4230,
	"./app-store/form-type-page/thumbs-up.svg": 3398,
	"./app-store/form-type-page/user-chart.svg": 9817,
	"./app-store/form-type-page/wallet.svg": 4772,
	"./app-store/imax-white.png": 8503,
	"./app-store/lendlease-white.png": 2215,
	"./app-store/logos/lumen.png": 6682,
	"./app-store/logos/post-consumer-brands.png": 5967,
	"./app-store/logos/saluda-hill-landscapes.png": 754,
	"./app-store/logos/te3co.png": 8439,
	"./app-store/logos/two-men-and-a-truck.png": 9736,
	"./app-store/logos/vip-lighting.png": 4687,
	"./app-store/modal-close.png": 3972,
	"./app-store/pdfs/construction_form.pdf": 5581,
	"./app-store/pge-white.png": 7520,
	"./app-store/redbull-white.png": 7470,
	"./app-store/slider-arrow.svg": 2754,
	"./appstore_headerbg.jpg": 3449,
	"./arrow.png": 1507,
	"./ban-regular.svg": 1311,
	"./bg-get-started-curve.png": 9938,
	"./bg-get-started.png": 9308,
	"./bg-home-tab.gif": 4454,
	"./bg-started-contents-bot.png": 5696,
	"./bg-started-contents-top.png": 3462,
	"./bg-started-contents.png": 4640,
	"./bg-tab.gif": 3546,
	"./blank.gif": 7581,
	"./builder_hero.png": 7346,
	"./builder_hero_new.png": 1941,
	"./bul-faq.gif": 9945,
	"./bul-howto.gif": 4540,
	"./but-click-here.png": 2331,
	"./but-close.png": 8986,
	"./but-create-app.png": 7458,
	"./but-how-it-works.gif": 9930,
	"./but-search-lrg.png": 7034,
	"./but-upload-form.png": 4107,
	"./button-small-grey-sprite.png": 7302,
	"./canv-signup-new_logo.jpg": 3432,
	"./canvas-logo.png": 7224,
	"./canvas_logo.svg": 7737,
	"./canvas_logo_black.svg": 7757,
	"./canvas_logo_wModifier.svg": 5620,
	"./canvas_og.png": 1993,
	"./cellphone_generic_full.jpg": 1400,
	"./cellphone_generic_thumb.jpg": 4259,
	"./circlearrow.svg": 9244,
	"./clipboard-list-check.svg": 3101,
	"./clock-regular.svg": 9434,
	"./close.png": 6088,
	"./cloud-upload-regular.svg": 4625,
	"./covid19-laptop-screen.png": 8271,
	"./custom.png": 8403,
	"./customers_company_logos.png": 3890,
	"./customize.png": 733,
	"./demo-icon-sml.png": 8238,
	"./dispatch.png": 7672,
	"./down_arrow.gif": 5183,
	"./download-page-imgs-01.png": 9299,
	"./download-page-imgs-02.png": 3707,
	"./download-page-imgs-03.png": 6305,
	"./download-regular.svg": 8634,
	"./downwards-right.svg": 6659,
	"./edit_app_status_icon.png": 989,
	"./edit_off.png": 5084,
	"./edit_over.png": 165,
	"./editicon.png": 6481,
	"./error_page_robot.png": 7819,
	"./favicon_new.png": 2035,
	"./feature-icons/calculations.png": 4734,
	"./feature-icons/conditional_fields.png": 4552,
	"./feature-icons/dispatch.png": 4394,
	"./feature-icons/gps.png": 9650,
	"./feature-icons/image.png": 2765,
	"./feature-icons/mobile_payments.png": 5054,
	"./feature-icons/reference_data.png": 9518,
	"./feature-icons/signature.png": 7188,
	"./feature-icons/submission_editing.png": 437,
	"./feature-icons/workflow.png": 9587,
	"./feature-image.png": 8666,
	"./form-background-bottom.png": 275,
	"./form-background-top.png": 6953,
	"./form-status-accepted.gif": 5844,
	"./form-status-approved.gif": 7606,
	"./form-status-completed.gif": 14,
	"./form-status-declined.gif": 3073,
	"./form-status-evaluated.gif": 4278,
	"./form-status-in-progress.gif": 2702,
	"./form-status-needs-merch.gif": 7147,
	"./form-status-new.gif": 4899,
	"./form-status-pending.gif": 5568,
	"./form-status-published.gif": 1627,
	"./form-status-rejected.gif": 5121,
	"./form-status-retired.gif": 4706,
	"./form-status-revision-accepted.gif": 1470,
	"./form-status-revision-completed.gif": 1340,
	"./form-status-revision-declined.gif": 3555,
	"./form-status-revision-requested.gif": 979,
	"./form_table_sprite.png": 3469,
	"./forms-section-button.gif": 8493,
	"./foundry-extras/facebook-f-brands.svg": 4833,
	"./foundry-extras/linkedin-in-brands.svg": 8890,
	"./foundry-extras/twitter-brands.svg": 8943,
	"./gavel-regular.svg": 5625,
	"./gc_logo_nemetschek.svg": 8205,
	"./gc_logo_nemetschek_2.svg": 9490,
	"./gocanvas_mailerlogo.png": 2008,
	"./google-icon.svg": 2266,
	"./google-play-badge_135px.png": 8494,
	"./google-play-badge_275px.png": 5333,
	"./hamburger-black.svg": 4584,
	"./header_img.png": 7761,
	"./help-icon.png": 8865,
	"./home-subnav-background.png": 5238,
	"./homepage/builder-hero.png": 6746,
	"./homepage/builder-hero.svg": 4546,
	"./homepage/builder-hero@2x.png": 4775,
	"./homepage/builder-hero@3x.png": 5452,
	"./homepage/builder-hero@4x.png": 6565,
	"./homepage/builder-hero@5x.png": 6666,
	"./homepage/coop-logo.png": 890,
	"./homepage/header-collage-au.png": 5337,
	"./homepage/lendlease.png": 2016,
	"./homepage/mirac.png": 1999,
	"./homepage/pge.png": 871,
	"./homepage/redbull.png": 317,
	"./icn-L.png": 5093,
	"./icn-blog.png": 7589,
	"./icn-fb-footer.png": 8269,
	"./icn-linkedin-footer.png": 6799,
	"./icn-multi-app.png": 3912,
	"./icn-play.png": 4887,
	"./icn-rss-footer.png": 6089,
	"./icn-twitter-footer.png": 826,
	"./icon_alert.png": 8274,
	"./icon_check.png": 7864,
	"./icon_close.png": 2812,
	"./icon_info.png": 2562,
	"./icons_apps_feature_sprite.svg": 5829,
	"./icons_enabled_sprite.svg": 3721,
	"./laptop-screen.png": 4805,
	"./library_item_types/computer.png": 21,
	"./library_item_types/work_order.png": 1980,
	"./logo-gocanvas-drop-transparent.svg": 4642,
	"./logo.png": 9783,
	"./logo1.png": 1966,
	"./logo2.png": 7717,
	"./logo3.png": 1804,
	"./logo4.png": 1699,
	"./logo5.png": 3946,
	"./logo6.png": 8705,
	"./mast_bkgnd.png": 8134,
	"./mirvac.svg": 5675,
	"./mobile-regular.svg": 7984,
	"./morethan 10 users.png": 8077,
	"./need-a-demo.png": 2934,
	"./nest_bkgnd.png": 9363,
	"./new-form-button.gif": 3809,
	"./new-user-button.gif": 1884,
	"./new_default_icon.png": 2206,
	"./null-image.png": 8609,
	"./onboard/devices.png": 2862,
	"./outer-highlight.svg": 8317,
	"./patterns/shattered.png": 9206,
	"./personalized-demo.png": 5838,
	"./phone.svg": 5567,
	"./pixel_transparent153.png": 8526,
	"./play-circle-regular.svg": 4031,
	"./pricing-page-call.png": 5147,
	"./pricing-page-pro-serv.png": 5413,
	"./pricing-page-training.png": 2465,
	"./pricing/Business.png": 7045,
	"./pricing/Business_PricingPage.png": 3779,
	"./pricing/COVID_19_CDC_Guidelines.pdf": 6845,
	"./pricing/Coronavirus_Employee_Waiver.pdf": 5197,
	"./pricing/Daily_Employee_Screening.pdf": 7323,
	"./pricing/Dashboards.svg": 6083,
	"./pricing/Enterprise.png": 9790,
	"./pricing/Enterprise_PricingPage.png": 7212,
	"./pricing/HVAC.svg": 8694,
	"./pricing/Hazard_Tracking.svg": 8392,
	"./pricing/Health_Care.svg": 1842,
	"./pricing/Health_Screening.svg": 6703,
	"./pricing/Incident_Report.pdf": 3519,
	"./pricing/Individual.png": 7706,
	"./pricing/IndividualPlan_PricingPage.png": 9789,
	"./pricing/Job_Safety_Analysis.pdf": 2723,
	"./pricing/Maintenance_Agreement.pdf": 9768,
	"./pricing/Paid_Faster.svg": 8726,
	"./pricing/Profesional_PricingPage.png": 9863,
	"./pricing/Professional.png": 7934,
	"./pricing/Safety.svg": 1638,
	"./pricing/Secure_Storage.svg": 3937,
	"./pricing/Toolbox_Talk.pdf": 2846,
	"./pricing/Truck_Supply_Checklist.pdf": 7460,
	"./pricing/Work_Order.pdf": 4950,
	"./pricing/fa-close.png": 4035,
	"./pricing/personalized-demo.jpg": 329,
	"./pricing/pricing-plan-header-bg.jpg": 8303,
	"./pricing/usd-circle-regular.png": 3765,
	"./redesign_2021/CalculationsPhone.png": 554,
	"./redesign_2021/Collect.png": 7790,
	"./redesign_2021/Create.png": 8794,
	"./redesign_2021/FormBuilderPhone.png": 9387,
	"./redesign_2021/Header-Image.png": 5181,
	"./redesign_2021/ImageCapturePhone.png": 5437,
	"./redesign_2021/SignatureCapPhone.png": 9030,
	"./redesign_2021/View.png": 4513,
	"./redesign_2021/c2.png": 1849,
	"./redesign_2021/calendar-alt.svg": 4425,
	"./redesign_2021/capterra.png": 488,
	"./redesign_2021/clock-regular.svg": 5682,
	"./redesign_2021/get-app.png": 1602,
	"./redesign_2021/search-regular.svg": 6910,
	"./redesign_2021/software-advice.png": 7608,
	"./redesign_2021/user-hard-hat.svg": 7994,
	"./search-submit.gif": 9394,
	"./share.png": 8629,
	"./show-template-button.gif": 5646,
	"./signup-graphic.jpg": 545,
	"./step-arrow.png": 5724,
	"./store.svg": 8944,
	"./strikethrough.svg": 334,
	"./submission-term-background.gif": 8133,
	"./subnav-background.png": 6202,
	"./subscriber-logos/lendlease.png": 7949,
	"./subscriber-logos/pge.png": 2634,
	"./subscriber-logos/redbull.png": 392,
	"./sufybanner.png": 7247,
	"./suyf_laptop_desktop .png": 4025,
	"./svg/Dispatch.svg": 8362,
	"./svg/MyCanvas.svg": 590,
	"./table-sort-down.gif": 7962,
	"./table-sort-up.gif": 1054,
	"./tip-box-top-grey.gif": 9614,
	"./tip-box-top.gif": 4034,
	"./toolkits/COVID-desktop-ecosystem.jpg": 561,
	"./toolkits/COVID-desktop-ecosystem.png": 4809,
	"./toolkits/COVID-desktop-header.jpg": 5558,
	"./toolkits/COVID-mobile-ecosystem.jpg": 341,
	"./toolkits/COVID-mobile-ecosystem.png": 9365,
	"./toolkits/COVID-mobile-header.jpg": 9954,
	"./toolkits/COVID-phones-overlay.png": 8768,
	"./toolkits/COVID19-header-small.jpg": 707,
	"./toolkits/COVID19-video.png": 8109,
	"./toolkits/COVIDicon-1.svg": 7531,
	"./toolkits/COVIDicon-2.svg": 6168,
	"./toolkits/COVIDicon-3.svg": 4089,
	"./toolkits/COVIDicon-4.svg": 8854,
	"./toolkits/HVAC-desktop-dataViz.png": 9361,
	"./toolkits/HVAC-desktop-ecosystem.jpg": 6046,
	"./toolkits/HVAC-desktop-ecosystem.png": 698,
	"./toolkits/HVAC-desktop-header.jpg": 3067,
	"./toolkits/HVAC-mobile-dataViz.png": 1219,
	"./toolkits/HVAC-mobile-ecosystem.jpg": 3787,
	"./toolkits/HVAC-mobile-ecosystem.png": 5980,
	"./toolkits/HVAC-mobile-header.jpg": 2341,
	"./toolkits/HVAC-phones-overlay.png": 9629,
	"./toolkits/HVAC-toolkit-header.jpg": 9137,
	"./toolkits/block-1-image.png": 5255,
	"./toolkits/block-2-image.png": 4304,
	"./toolkits/block-3-image.png": 8889,
	"./toolkits/block-4-image.png": 402,
	"./toolkits/block-5-image.png": 747,
	"./toolkits/blog-img1.jpg": 1501,
	"./toolkits/blog-img2.jpg": 9221,
	"./toolkits/blog-img3.jpg": 9535,
	"./toolkits/check-circle-filled.svg": 6847,
	"./toolkits/checkmark-bullets.png": 1669,
	"./toolkits/checkmark-bullets.svg": 7690,
	"./toolkits/comments-dollar-light.svg": 6447,
	"./toolkits/ecosystem.png": 1590,
	"./toolkits/edit-light.svg": 1648,
	"./toolkits/exclamation-triangle-light.svg": 408,
	"./toolkits/icon-1-tempscan.svg": 2090,
	"./toolkits/icon-2-screening.svg": 7930,
	"./toolkits/icon-3-confidence.svg": 749,
	"./toolkits/icon-4-protect.svg": 8793,
	"./toolkits/icon-play-circle.png": 2099,
	"./toolkits/icon-play-circle.svg": 9364,
	"./toolkits/line-leftend.png": 1775,
	"./toolkits/line-middle.png": 3878,
	"./toolkits/line-rightend.png": 3852,
	"./toolkits/times-octagon-light.svg": 3250,
	"./toolkits/toolkits-analytics-small.png": 7800,
	"./tools-regular.svg": 2489,
	"./tools.svg": 9106,
	"./trashicon.png": 633,
	"./underline-white.svg": 6035,
	"./underline.svg": 4147,
	"./up_arrow.gif": 2432,
	"./vendor_activation_email/logo.png": 9384,
	"./welcome-rocket.png": 3087,
	"./windows_download_logo_135px.png": 4756,
	"./workflow.png": 7253
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 751;